import React,{useEffect} from 'react';
import '../Assets/Additionalcss/Corpcss.css';
import corplogo from '../Assets/Images/corp logo.png';
import {Link} from 'react-router-dom';
import {useLocation} from 'react-router-dom';

function Corpsidebar({sidebar,openLogForm}) {
    
 let role;
    useEffect(()=>{

     role=localStorage.getItem('RoleId')
     if(role==='02'){
        document.getElementById("Corp-Adduser").style.display="none";

            document.getElementById("Corp-Assign").style.display="none"
     }

     });

    



     //assigning location variable
     const location = useLocation();

     //destructuring pathname from location
     const { pathname } = location;
 
     //Javascript split method to get the name of the path in array
     const splitLocation = pathname.split("/");



    


    return (
        <div  className ={sidebar ? "corp-sidebar corp-sidebar--open" : "corp-sidebar"}  id="corp-sidebar">
        <div className='corp-sidebar-title'>
            <div className='corp-sidebar-img'>
                <img src={corplogo} alt="logo"/>&nbsp;&nbsp;
                <span>KDP CORP </span>
            </div>
           
        </div>
    
       <div className='corp-sidebar-menu'>
        {/* <div className='sidebar-link active-menu-link '>
            <i className='fa fa-home'></i>
            <a href="#">Dashboard</Link>
        </div> */}
        
        <div className= {splitLocation[1]=== "Corpadduser" ? "active-Corp":
         splitLocation[1]=== "CorpAddRole" ? "active-Corp":
        'corp-sidebar-link'} id="Corp-Adduser">
        <i class="fa-solid fa-user-plus"></i>&nbsp;&nbsp;&nbsp;
            <Link to="/Corpadduser">Add User</Link>
        </div>
      
        <div className= {splitLocation[1]=== "CorpProfile" ? "active-Corp" : 'corp-sidebar-link'}>
        <i class="fa-solid fa-user"></i>&nbsp;&nbsp;&nbsp;&nbsp;
            <Link to="/CorpProfile">Profile</Link>
        </div>
       
        <div className= {splitLocation[1]=== "Corpsection" ? "active-Corp" :
         splitLocation[1]=== "CorpLifehere" ? "active-Corp" :
         splitLocation[1]=== "CorpLHContent" ? "active-Corp" :
         splitLocation[1]=== "CorpLHImages" ? "active-Corp" :
         splitLocation[1]=== "CorpGivingback" ? "active-Corp" :
         splitLocation[1]=== "CorpGBContent" ? "active-Corp" :
         splitLocation[1]=== "CorpGBImages" ? "active-Corp" :
         splitLocation[1]=== "CorpCareer" ? "active-Corp" :
         splitLocation[1]=== "CorpContentCareers" ? "active-Corp" :
         splitLocation[1]=== "CorpOurteam" ? "active-Corp" :
         splitLocation[1]=== "CorpOurteamContent" ? "active-Corp" :
         'corp-sidebar-link'}>
        <i class="fa-solid fa-section"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <Link to="/Corpsection">Section</Link>
        </div>
     
    
        
    
        <div className= {splitLocation[1]=== "Corpassign" ? "active-Corp" : 'corp-sidebar-link'}id="Corp-Assign">
        
        <i class="fas fa-tasks"></i>&nbsp;&nbsp;&nbsp;&nbsp;
            <Link to="/Corpassign">Assign</Link>
        </div>
    
    
        <div className='corp-sidebar-link'>
        <i class="fa-solid fa-right-from-bracket"></i>&nbsp; &nbsp;&nbsp;
            <Link to=" "onClick={openLogForm} >Logout</Link>
        </div>
       
        
       </div>


       {/* <div className="Paropop-fade" id="modalLogoutForm" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document">
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">LOG OUT</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

<form id='form'>

   <div className="modal-body mx-3">

        <div className="md-form mb-5">
            <div className='text-center'>
          <h5>Are you sure want to logout?</h5>
          </div>
        </div>

   </div>

      <div className="modal-footer d-flex justify-content-center">
        <Link to="/"><button className="Corp-adduser-button" onClick={removelocalstorage} type='submit'>Confirm</button></Link>
        <button className="Corp-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
      </div>

      </form>
      
    </div>
  </div>
</div> */}

    
        </div>
    );
}

export default Corpsidebar;